import { Trans } from 'react-i18next'

import * as Icon from '@makyoapp/makyo-icon/icon'

import Notice from './Notice'

/**
 * CheckEmailNotice is a function component that displays a notice message
 * instructing the user to check their email for a 6-digit OTP code.
 * It uses the Trans component from react-i18next for localization and interpolation.
 *
 * @param {string} props.email - The user's email where the OTP was sent.
 *
 * @returns {JSX.Element} A div element containing the notice message.
 */
function CheckEmailNotice({ email }: { email: string }) {
  return (
    <div className='mb-4'>
      <Notice icon={<Icon.Lock24 className='fill-zinc-500' />}>
        <Trans
          i18nKey='loginEmailSent'
          default="We've sent a 6-digit OTP code to <1>{{email}}</1>. The code expires shortly, so please enter it soon."
          values={{ email }}
          components={{ 1: <strong /> }}
        />
      </Notice>
    </div>
  )
}

export default CheckEmailNotice
